// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"f0624dcd","830":"b29eaebb"}[chunkId] + ".chunk.js";
};